






import Vue from 'vue';
import baseMenu from './BaseMenu.vue';

export default Vue.extend({
    components: { baseMenu },
    data: () => {
        return {
            links: [
                {
                    icon: 'mdi-account-multiple',
                    label: 'labels.utenti',
                    href: '/utenti',
                },
            ],
        };
    },
});
